import React, { useMemo } from 'react'
import { strings } from '@constants'
import { Button, TableColumns } from '@base'
import { HeaderWapper, Heading, TableContainer, TableWapper, Wapper } from '../style'
import { paths } from '@routes'
import { useNavigate } from 'react-router'

const OrganicQuoteReceived = ({ organicQuote }) => {
	const navigate = useNavigate()

	const buttonClickHandler = (e, row) => {
		e.stopPropagation()
		navigate(paths.admin_manage_enquiry_manage(row.enquiry_id))
	}

	const columns = useMemo(
		() => [
			TableColumns.idColumn({}),
			TableColumns.dateColumn({ key: 'enquiry_date', label: strings('enquiry', 'date'), align: 'left', mobile: false }),
			{
				label: strings('supplier'),
				key: (item) => (item?.supplier_name ? item?.supplier_name : '-'),
				mobile: true,
			},
			{
				label: strings('quantity'),
				key: (item) => (item?.quantity ? `${item?.quantity} MT` : '-'),
				mobile: true,
			},
			{
				label: strings('phone'),
				key: (item) => (item?.phone_number ? item?.phone_number : '-'),
				mobile: true,
			},
			TableColumns.actionsColumn({
				align: 'center',
				renderer: (row) => {
					return (
						<Button small type='secondary' onClick={(e) => buttonClickHandler(e, row)}>
							View Quote
						</Button>
					)
				},
				mobile: false,
			}),
		],
		[]
	)
	return (
		<Wapper FlexColumn>
			<HeaderWapper>
				<Heading>Organic Quote Received</Heading>
			</HeaderWapper>
			<TableContainer>
				<TableWapper
					fullHeight={true}
					data={organicQuote || []}
					columns={columns}
					rowsToDisplay={10}
					totalItemCount={50}
					page={0}
					onRowClick={() => {}}
					rowClickable={false}
					hideFooter
				/>
			</TableContainer>
		</Wapper>
	)
}

export default OrganicQuoteReceived
